
import Social from "./components/Social/Social";
import '../Header/Header.scss'
import Login from "./components/Login/Login";
import Cart from "./components/Cart";
import HeaderNav from "./components/HeaderNav";
import Favourite from "./components/Favourite";


const Header = ({cartCount,favCount})=>{

    return(
<header className="header">
                <div className="header__top-line"></div>
                
                <div className="header__top">
                    <div className="container">
                        <div className="header__top-wrap">
                                <Social/>
                            <div className="header__top-right">
                                <Login/>
                                <Favourite favCount={favCount}/>
                                <Cart cartCount={cartCount}/>
                            </div>
                        </div>
                        
                    </div>
                </div>
                    
                        <div className="header__bottom">
                            <div className="container">
                                <HeaderNav/>
                           </div>
                        </div>
                       
                   
        </header>
    )
}

export default Header;